export default __webpack_public_path__ + "static/media/oscer-pres-haematemesis.ce801bf1.svg";